(async () => {
    const { Core } = await importModule('Core');
    const { $replaceContent } = await importModule('Utils');

    customElements.define('x-cart', class extends Core {
        elements = {
            items: '[data-cart-form]',
            subtotalBlock: '[data-cart-subtotal-block]'
        }
        
        subscriptions = {
            'cart:update': '_onUpdate',
        }

        render() {
            this.subscribe('cart:update', { global: true });
        };

        _onUpdate(data) {
            data.getCount() > 0 ? this._update(data) : this._empty(data);
        }

        _update({ getSubtotal, getItems, getSubtotalBlock }) { 
            $replaceContent(this.$subtotalBlock, getSubtotalBlock());
            $replaceContent(this.$items, getItems());
        }

        _empty({ getEmptyMsg }) { 
            $replaceContent(this, getEmptyMsg());
        }
    });
})();